import { 事業種別 } from "./types"


export function calculate月間雇用保険料(
  社長や役員等のような雇う側かどうか: boolean,
  is週20時間以上かつ31日以上の雇用見込み: boolean,
  残業代_通勤交通費_各種手当などをすべて足した対象月の実際の総支給額: number,
  事業種別: 事業種別,
): number {
  if (社長や役員等のような雇う側かどうか || !is週20時間以上かつ31日以上の雇用見込み) return 0;
  
  let 雇用保険料率: number;
  switch (事業種別) {
    case "一般": 雇用保険料率 = 0.006;
    case "農林水産": 雇用保険料率 = 0.007;
    case "建設": 雇用保険料率 =0.007;
  }

  // 酬月額ではなく実支給額に対して課税（雇用保険の特徴）
  return Math.floor(残業代_通勤交通費_各種手当などをすべて足した対象月の実際の総支給額 * 雇用保険料率);
}
